export default __webpack_public_path__ + "static/media/checked.ac3003df.svg";